import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { api } from "../lib/api";
import { useI18n } from "../i18n/I18nContext";
import Reveal from "./Reveal";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";

export const FaqSection = ({ title, orders = null, className = "", innerClassName = "max-w-3xl", emitSchema = false }) => {
  const { t } = useI18n();
  const [faq, setFaq] = useState([]);

  useEffect(() => { api.get("/faq").then((r) => setFaq(r.data)).catch(() => {}); }, []);

  const items = orders ? faq.filter((f) => orders.includes(f.order)) : faq;
  if (items.length === 0) return null;

  const faqSchema = emitSchema ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer },
    })),
  } : null;

  return (
    <section className={`py-16 lg:py-24 ${className}`} data-testid="faq-section">
      {faqSchema && <Helmet><script type="application/ld+json">{JSON.stringify(faqSchema)}</script></Helmet>}
      <div className={`mx-auto ${innerClassName} px-4 sm:px-6 lg:px-8`}>
        <Reveal className="text-center mb-10">
          <h2 className="font-heading text-3xl sm:text-4xl text-ink-900">{title || t("infosPage.faqTitle")}</h2>
        </Reveal>
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {items.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="bg-white rounded-2xl border border-black/5 px-5">
              <AccordionTrigger className="text-left font-body font-medium text-ink-900 hover:no-underline">{f.question}</AccordionTrigger>
              <AccordionContent className="text-ink-600 font-body">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FaqSection;
